// Example implementation in lib
// https://github.com/romkor/svelte-portal
import { get } from "svelte/store";
import { AppStore, AppType } from "../stores/AppStore";
import { getRootDocument } from "./Utils";
export function portal(el) {
    if (get(AppStore).type === AppType.EXTENSION) {
        getRootDocument("extension")
            .appendChild(el);
    }
    else if (get(AppStore).type === AppType.HIGHLIGHTER) {
        getRootDocument()
            .appendChild(el);
    }
    else if (get(AppStore).type === AppType.DASHBOARD) {
        getRootDocument("web").querySelector("body").appendChild(el);
    }
    return {
        destroy() {
            if (el.parentNode) {
                el.parentNode.removeChild(el);
            }
        },
    };
}
